.root {
  max-width: 1050px;
  height: 100%;
  color: var(--on-surface);
}

.sentiment {
  display: flex;
  gap: 0.25rem;
  align-items: center;
}

.icon {
  color: var(--on-surface);
}

.title {
  margin-bottom: 1rem;
}

.content {
  min-height: 300px;
}

.coverWrapper {
  display: flex;
  gap: 0.5rem;
}

.header {
  padding-bottom: 25px;
  background-color: var(--widget-header-background);
  background-image: url("@/assets/images/artsy-mountain-pink.png");
  background-repeat: no-repeat;
  background-position: top right;
  background-size: 510px 420px;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}

.cover {
  width: 40px;
  height: 40px;
  overflow: hidden;
  border-radius: var(--radius-full);
}

.channelTable {
  tr td {
    &:first-child {
      padding-left: 0;
    }

    &:last-child {
      padding-right: 0;
    }
  }
}

.spinner {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  > div {
    display: flex;
    align-self: center;
    margin-bottom: 5px;
  }
}
